var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDelete = function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.334 5.833h13.333M8.334 9.167v5m3.332-5v5m-7.5-8.334l.833 10A1.667 1.667 0 006.666 17.5h6.667a1.667 1.667 0 001.666-1.667l.834-10m-8.333 0v-2.5a.833.833 0 01.833-.833h3.334a.833.833 0 01.833.833v2.5",
    stroke: "#DB2A4A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgDelete;